import * as React from "react"
import { cn } from "../../lib/utils"

const Checkbox = React.forwardRef(({ className, checked, onCheckedChange, disabled, ...props }, ref) => {
  const handleChange = (e) => {
    if (onCheckedChange) {
      onCheckedChange(e.target.checked);
    }
  };

  return (
    <input
      type="checkbox"
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-sm border border-slate-300 dark:border-slate-600 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 accent-violet-600 dark:accent-violet-500 cursor-pointer",
        className
      )}
      ref={ref}
      checked={checked}
      onChange={handleChange}
      disabled={disabled}
      {...props}
    />
  );
});
Checkbox.displayName = "Checkbox"

export { Checkbox }
